import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPercent = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsxs("g", {
		transform: "translate(0 0) scale(1.2)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M8.33329 4.99984C8.33329 6.84079 6.84091 8.33317 4.99996 8.33317C3.15901 8.33317 1.66663 6.84079 1.66663 4.99984C1.66663 3.15889 3.15901 1.6665 4.99996 1.6665C6.84091 1.6665 8.33329 3.15889 8.33329 4.99984ZM6.66663 4.99984C6.66663 5.92031 5.92043 6.6665 4.99996 6.6665C4.07948 6.6665 3.33329 5.92031 3.33329 4.99984C3.33329 4.07936 4.07948 3.33317 4.99996 3.33317C5.92043 3.33317 6.66663 4.07936 6.66663 4.99984Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M18.3333 14.9998C18.3333 16.8408 16.8409 18.3332 15 18.3332C13.159 18.3332 11.6666 16.8408 11.6666 14.9998C11.6666 13.1589 13.159 11.6665 15 11.6665C16.8409 11.6665 18.3333 13.1589 18.3333 14.9998ZM16.6666 14.9998C16.6666 15.9203 15.9204 16.6665 15 16.6665C14.0795 16.6665 13.3333 15.9203 13.3333 14.9998C13.3333 14.0794 14.0795 13.3332 15 13.3332C15.9204 13.3332 16.6666 14.0794 16.6666 14.9998Z",
				fill: "currentColor"
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Shape_2",
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M16.345 1.84208C16.7083 2.12464 16.7738 2.6482 16.4912 3.01149L4.82454 18.0115C4.54198 18.3748 4.01842 18.4402 3.65513 18.1577C3.29184 17.8751 3.22639 17.3515 3.50895 16.9883L15.1756 1.98826C15.4582 1.62497 15.9817 1.55952 16.345 1.84208Z",
				fill: "currentColor"
			})
		]
	})]
});
const ForwardRef = forwardRef(SvgPercent);
export default ForwardRef;
